var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5340",
    "data-name": "Rectangle 5340",
    width: 71,
    height: 71,
    fill: "#fcbf49"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15351",
    "data-name": "Group 15351",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15350",
    "data-name": "Group 15350",
    transform: "translate(0.5 0.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29459",
    "data-name": "Path 29459",
    d: "M35.714,0a35.745,35.745,0,1,0,32.7,21.394A35.776,35.776,0,0,0,35.714,0m0,64.354a28.623,28.623,0,0,1-19.865-8.047,21.489,21.489,0,0,1,39.731,0,28.623,28.623,0,0,1-19.865,8.047M28.558,28.6a7.156,7.156,0,1,1,7.156,7.15,7.156,7.156,0,0,1-7.156-7.15M60.445,50.053a28.693,28.693,0,0,0-14-12.084,14.308,14.308,0,1,0-21.468,0,28.693,28.693,0,0,0-14,12.084,28.6,28.6,0,1,1,53.356-14.3,28.377,28.377,0,0,1-3.893,14.3",
    transform: "translate(-0.428 -0.428)",
    fill: "#fcbf49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.f8d50d6e479349f7d045166dc2447f66.svg";
export { ForwardRef as ReactComponent };